export const MST_BANK = [
  {
    "label": "ABN AMRO BANK - ABN AMRO BANK (ABNAMRO)",
    "value": "ABNAMRO"
  },
  {
    "label": "ALFA BANK - ALFA BANK (ALFABANK)",
    "value": "ALFABANK"
  },
  {
    "label": "ALFINDO BANK - ALFINDO BANK (ALFINDO)",
    "value": "ALFINDO"
  },
  {
    "label": "AMERICAN EXPRESS - EXCHANGE HOUSE JL RASUNA SAID (AMEX)",
    "value": "AMEX"
  },
  {
    "label": "ANZ BANK - SUDIRMAN (ANZ)",
    "value": "ANZ"
  },
  {
    "label": "ANZ PANIN BANK - ANZ PANIN BANK (ANZPANIN)",
    "value": "ANZPANIN"
  },
  {
    "label": "B I I - B I I (BII)",
    "value": "BII"
  },
  {
    "label": "B O T MITSUBISHI UFJ LTD - B O T MITSUBISHI UFJ LTD (MITSUBISHI)",
    "value": "MITSUBISHI"
  },
  {
    "label": "BANGKOK BANK LTD - BANGKOK BANK LTD (BANGKOK)",
    "value": "BANGKOK"
  },
  {
    "label": "BANK ACEH SYARIAH - BANK ACEH SYARIAH (BANKACEHSY)",
    "value": "BANKACEHSY"
  },
  {
    "label": "BANK AGRIS - BANK AGRIS (BANKAGRIS)",
    "value": "BANKAGRIS"
  },
  {
    "label": "BANK AGRO - BANK AGRO (BANKAGRO)",
    "value": "BANKAGRO"
  },
  {
    "label": "BANK AKITA - BANK AKITA (BANKAKITA)",
    "value": "BANKAKITA"
  },
  {
    "label": "BANK AMIN - BANK AMIN (BANKAMIN)",
    "value": "BANKAMIN"
  },
  {
    "label": "BANK ANTAR DAERAH - BANK ANTAR DAERAH (BAD)",
    "value": "BAD"
  },
  {
    "label": "BANK ARTHA GRAHA INTL - BANK ARTHA GRAHA INTL (ARTHAGRAHA)",
    "value": "ARTHAGRAHA"
  },
  {
    "label": "BANK ARTOS INDONESIA - BANK ARTOS INDONESIA (BANKARTOS)",
    "value": "BANKARTOS"
  },
  {
    "label": "BANK BISNIS INTL - BANK BISNIS INTL (BANKBISNIS)",
    "value": "BANKBISNIS"
  },
  {
    "label": "BANK BNI - TEBET (22)",
    "value": "22"
  },
  {
    "label": "BANK BNP LIPPO INDONESIA - BANK BNP LIPPO INDONESIA (BNPLIPPO)",
    "value": "BNPLIPPO"
  },
  {
    "label": "BANK BPD BANTEN",
    "value": "BPD BANTEN"
  },
  {
    "label": "BANK BTPN - BANK BTPN (BTPN)",
    "value": "BTPN"
  },
  {
    "label": "BANK BUKOPIN - BANK BUKOPIN (BUKOPIN)",
    "value": "BUKOPIN"
  },
  {
    "label": "BANK BUKOPIN - PUSAT (102)",
    "value": "102"
  },
  {
    "label": "BANK BUMI ARTA IND - BANK BUMI ARTA IND (BBA)",
    "value": "BBA"
  },
  {
    "label": "BANK BUMIPUTERA - PRAMUKA JAKARTA (BUMIPUTERA)",
    "value": "BUMIPUTERA"
  },
  {
    "label": "BANK CAPITAL INDONESIA - BANK CAPITAL INDONESIA (CAPITAL)",
    "value": "CAPITAL"
  },
  {
    "label": "BANK CENTURY TBK - BANK CENTURY TBK (CENTURY)",
    "value": "CENTURY"
  },
  {
    "label": "BANK CHINA CONSTRUCTION IND - BANK CHINA CONSTRUCTION IND (CHINACONST)",
    "value": "CHINACONST"
  },
  {
    "label": "BANK CHINATRUST INDONESIA - BANK CHINATRUST INDONESIA (CHINATRUST)",
    "value": "CHINATRUST"
  },
  {
    "label": "BANK COMMONWEALTH - BANK COMMONWEALTH (COMMONWLTH)",
    "value": "COMMONWLTH"
  },
  {
    "label": "BANK DANAMON - BANK DANAMON (DANAMON)",
    "value": "DANAMON"
  },
  {
    "label": "BANK DANAMON - MENARA BANK DANAMON JAKARTA (3870)",
    "value": "3870"
  },
  {
    "label": "BANK DANAMON - WARUNG BUNCIT (72)",
    "value": "72"
  },
  {
    "label": "BANK DBS INDONESIA - BANK DBS INDONESIA (DBS)",
    "value": "DBS"
  },
  {
    "label": "BANK DIGITAL BCA - BANK DIGITAL BCA (DIGITALBCA)",
    "value": "DIGITALBCA"
  },
  {
    "label": "BANK DINAR INDONESIA          SURABAYA (BANKDINAR)",
    "value": "BANKDINAR"
  },
  {
    "label": "BANK DIPO INT - BANK DIPO INT (BANKDIPO)",
    "value": "BANKDIPO"
  },
  {
    "label": "BANK DJASA ARTA - BANK DJASA ARTA (DJASAARTA)",
    "value": "DJASAARTA"
  },
  {
    "label": "BANK DKI - BANK DKI (BANKDKI)",
    "value": "BANKDKI"
  },
  {
    "label": "BANK EKONOMI RAHARJA - BANK EKONOMI RAHARJA (EKONOMIRHJ)",
    "value": "EKONOMIRHJ"
  },
  {
    "label": "BANK EKSEKUTIF INTL - BANK EKSEKUTIF INTL (EKSEKUTIF)",
    "value": "EKSEKUTIF"
  },
  {
    "label": "BANK EKSPOR INDONESIA - BANK EKSPOR INDONESIA (BANKEKSPOR)",
    "value": "BANKEKSPOR"
  },
  {
    "label": "BANK FAMA INTL - BANK FAMA INTL (BANKFAMA)",
    "value": "BANKFAMA"
  },
  {
    "label": "BANK FINCONESIA - BANK FINCONESIA (FINCONESIA)",
    "value": "FINCONESIA"
  },
  {
    "label": "BANK GANESHA - BANK GANESHA (GANESHA)",
    "value": "GANESHA"
  },
  {
    "label": "BANK HAGAKITA - BANK HAGAKITA (HAGAKITA)",
    "value": "HAGAKITA"
  },
  {
    "label": "BANK HANA - BANK HANA (BANKHANA)",
    "value": "BANKHANA"
  },
  {
    "label": "BANK HARDA INTL - BANK HARDA INTL (BANKHARDA)",
    "value": "BANKHARDA"
  },
  {
    "label": "BANK HARFA - BANK HARFA (BANKHARFA)",
    "value": "BANKHARFA"
  },
  {
    "label": "BANK HS1906 - BANK HS1906 (BANKHS1906)",
    "value": "BANKHS1906"
  },
  {
    "label": "BANK I F I - BANK I F I (BANKIFI)",
    "value": "BANKIFI"
  },
  {
    "label": "BANK ICBC INDONESIA - BANK ICBC INDONESIA (BANKICBC)",
    "value": "BANKICBC"
  },
  {
    "label": "BANK INA PERDANA - BANK INA PERDANA (INAPERDANA)",
    "value": "INAPERDANA"
  },
  {
    "label": "BANK INDEX SELINDO - BANK INDEX SELINDO (INDEXSEL)",
    "value": "INDEXSEL"
  },
  {
    "label": "BANK INDOMONEX - BANK INDOMONEX (INDOMONEX)",
    "value": "INDOMONEX"
  },
  {
    "label": "BANK JABAR - BANK JABAR (BANKJABAR)",
    "value": "BANKJABAR"
  },
  {
    "label": "BANK JABAR SYARIAH - BANK JABAR SYARIAH (JABARSYA)",
    "value": "JABARSYA"
  },
  {
    "label": "BANK JASA JAKARTA - BANK JASA JAKARTA (BANKJASA)",
    "value": "BANKJASA"
  },
  {
    "label": "BANK JATIM - BANK JATIM (BANKJATIM)",
    "value": "BANKJATIM"
  },
  {
    "label": "BANK KEB INDONESIA - BANK KEB INDONESIA (BANKKEB)",
    "value": "BANKKEB"
  },
  {
    "label": "Bank Kesawan - Jakarta (1670015)",
    "value": "1670015"
  },
  {
    "label": "BANK KESEJAHTERAAN EKONOMI - BANK KESEJAHTERAAN EKONOMI (SEJAHTERA)",
    "value": "SEJAHTERA"
  },
  {
    "label": "BANK LAMPUNG - BANK LAMPUNG (BKLAMPUNG)",
    "value": "BKLAMPUNG"
  },
  {
    "label": "BANK MANDIRI - BANK MANDIRI (MANDIRI)",
    "value": "MANDIRI"
  },
  {
    "label": "BANK MANDIRI - THAMRIN (3660)",
    "value": "3660"
  },
  {
    "label": "BANK MANDIRI TASPEN",
    "value": "MNDTASPEN"
  },
  {
    "label": "BANK MASPION INDONESIA - BANK MASPION INDONESIA (MASPION)",
    "value": "MASPION"
  },
  {
    "label": "BANK MAYAPADA - BANK MAYAPADA (MAYAPADA)",
    "value": "MAYAPADA"
  },
  {
    "label": "BANK MAYORA - BANK MAYORA (MAYORA)",
    "value": "MAYORA"
  },
  {
    "label": "BANK MEGA - BANK MEGA (MEGA)",
    "value": "MEGA"
  },
  {
    "label": "BANK MESTIKA DHARMA - BANK MESTIKA DHARMA (MESTIKA)",
    "value": "MESTIKA"
  },
  {
    "label": "BANK METRO EXPRESS - BANK METRO EXPRESS (BANKMETRO)",
    "value": "BANKMETRO"
  },
  {
    "label": "BANK MITRANIAGA - BANK MITRANIAGA (MITRANIAGA)",
    "value": "MITRANIAGA"
  },
  {
    "label": "BANK MIZUHO INDONESIA - BANK MIZUHO INDONESIA (MIZUHO)",
    "value": "MIZUHO"
  },
  {
    "label": "BANK MUAMALAT IND - BANK MUAMALAT IND (MUAMALAT)",
    "value": "MUAMALAT"
  },
  {
    "label": "BANK MULTI ARTA SENTOSA - BANK MULTI ARTA SENTOSA (MULTIARTA)",
    "value": "MULTIARTA"
  },
  {
    "label": "BANK MUTIARA KANTOR PUSAT - JAKARTA (MUTIARA)",
    "value": "MUTIARA"
  },
  {
    "label": "BANK NAGARI - BANK NAGARI (BANKNAGARI)",
    "value": "BANKNAGARI"
  },
  {
    "label": "BANK NATIONAL NOBU - BANK NATIONAL NOBU (NOBUBANK)",
    "value": "NOBUBANK"
  },
  {
    "label": "BANK NEO COMMERCE - BANK NEO COMMERCE (BANKNEO)",
    "value": "BANKNEO"
  },
  {
    "label": "BANK NIAGA - BANK NIAGA (NIAGA)",
    "value": "NIAGA"
  },
  {
    "label": "BANK NISP - BANK NISP (NISP)",
    "value": "NISP"
  },
  {
    "label": "BANK NOBU - BANK NOBU (BANKNOBU)",
    "value": "BANKNOBU"
  },
  {
    "label": "BANK NUSANTARA PARAHYANGAN - BANK NUSANTARA PARAHYANGAN (NUSANTARA)",
    "value": "NUSANTARA"
  },
  {
    "label": "BANK OCBC INDONESIA - BANK OCBC INDONESIA (OCBC)",
    "value": "OCBC"
  },
  {
    "label": "BANK OF AMERICA - BANK OF AMERICA (BOA)",
    "value": "BOA"
  },
  {
    "label": "BANK OF CHINA LIMITED - BANK OF CHINA LIMITED (CHINALTD)",
    "value": "CHINALTD"
  },
  {
    "label": "BANK OF INDIA INDONESIA - BANK OF INDIA INDONESIA (BANKINDIA)",
    "value": "BANKINDIA"
  },
  {
    "label": "BANK PANIN - BANK PANIN (PANIN)",
    "value": "PANIN"
  },
  {
    "label": "BANK PERMATA - BANK PERMATA (PERMATA)",
    "value": "PERMATA"
  },
  {
    "label": "BANK PERSYARIKATAN IND - BANK PERSYARIKATAN IND (BPI)",
    "value": "BPI"
  },
  {
    "label": "BANK PUNDI INDONESIA - KP PUSAT JAKARTA (PUNDI)",
    "value": "PUNDI"
  },
  {
    "label": "BANK PURBA DANARTA - BANK PURBA DANARTA (BANKPURBA)",
    "value": "BANKPURBA"
  },
  {
    "label": "BANK QNB - BANK QNB INDONESIA (KESAWAN)",
    "value": "KESAWAN"
  },
  {
    "label": "BANK RESONA PERDANIA - BANK RESONA PERDANIA (BANKRESONA)",
    "value": "BANKRESONA"
  },
  {
    "label": "BANK ROYAL IND - BANK ROYAL IND (BANKROYAL)",
    "value": "BANKROYAL"
  },
  {
    "label": "BANK SHINHAN - BANK SHINHAN (SHINHAN)",
    "value": "SHINHAN"
  },
  {
    "label": "BANK SINAR HARAPAN BALI - BANK SINAR HARAPAN BALI (SHB)",
    "value": "SHB"
  },
  {
    "label": "BANK SINARMAS - BANK SINARMAS (SINARMAS)",
    "value": "SINARMAS"
  },
  {
    "label": "BANK SOCIETE GENERALE IND - BANK SOCIETE GENERALE IND (BANKSOCGEN)",
    "value": "BANKSOCGEN"
  },
  {
    "label": "BANK SRI PARTHA - BANK SRI PARTHA (SRIPARTHA)",
    "value": "SRIPARTHA"
  },
  {
    "label": "BANK SULUT - BANK SULUT (BANKSULUT)",
    "value": "BANKSULUT"
  },
  {
    "label": "BANK SUMBAR - BANK SUMBAR (BANKSUMBAR)",
    "value": "BANKSUMBAR"
  },
  {
    "label": "BANK SUMITOMO MITSUI IND - BANK SUMITOMO MITSUI IND (SUMITOMO)",
    "value": "SUMITOMO"
  },
  {
    "label": "BANK SUMSEL - BANK SUMSEL (BANKSUMSEL)",
    "value": "BANKSUMSEL"
  },
  {
    "label": "BANK SUMSEL SYARIAH - BANK SUMSEL SYARIAH (SUMSELSYA)",
    "value": "SUMSELSYA"
  },
  {
    "label": "BANK SUMUT - BANK SUMUT (BANKSUMUT)",
    "value": "BANKSUMUT"
  },
  {
    "label": "BANK SUMUT SYARIAH - BANK SUMUT SYARIAH (SUMUTSYA)",
    "value": "SUMUTSYA"
  },
  {
    "label": "BANK SWADESI - BANK SWADESI (SWADESI)",
    "value": "SWADESI"
  },
  {
    "label": "BANK SWAGUNA - BANK SWAGUNA (SWAGUNA)",
    "value": "SWAGUNA"
  },
  {
    "label": "BANK SYARIAH INDONESIA - BANK SYARIAH INDONESIA (SYAMANDIRI)",
    "value": "SYAMANDIRI"
  },
  {
    "label": "BANK TABUNGAN NEGARA - BANK TABUNGAN NEGARA (BTN)",
    "value": "BTN"
  },
  {
    "label": "BANK U I B - BANK U I B (UIB)",
    "value": "UIB"
  },
  {
    "label": "BANK UOB INDONESIA - BANK UOB INDONESIA (UOB)",
    "value": "UOB"
  },
  {
    "label": "BANK VICTORIA INTL - BANK VICTORIA INTL (VICTORIA)",
    "value": "VICTORIA"
  },
  {
    "label": "BANK VICTORIA SYARIAH - BANK VICTORIA SYARIAH (VICSYARIAH)",
    "value": "VICSYARIAH"
  },
  {
    "label": "BANK WINDU KENTJANA INTL - BANK WINDU KENTJANA INTL (BANKWINDU)",
    "value": "BANKWINDU"
  },
  {
    "label": "BANK WOORI INDONESIA - BANK WOORI INDONESIA (BANKWOORI)",
    "value": "BANKWOORI"
  },
  {
    "label": "BANK YUDHA BAKTI - BANK YUDHA BAKTI (YUDHABAKTI)",
    "value": "YUDHABAKTI"
  },
  {
    "label": "BCA - GRAHA INTI FAUZI (3871)",
    "value": "3871"
  },
  {
    "label": "BCA - KCP CINERE (1583)",
    "value": "1583"
  },
  {
    "label": "BCA - MAL ARTHA GADING (4290)",
    "value": "4290"
  },
  {
    "label": "BCA - PONDOK INDAH (183)",
    "value": "183"
  },
  {
    "label": "BCA - SUDIRMAN (35)",
    "value": "35"
  },
  {
    "label": "BCA - WAHID HASYIM (BCA)",
    "value": "BCA"
  },
  {
    "label": "BCA SYARIAH - JAKARTA (BCA SYARIA)",
    "value": "BCA SYARIA"
  },
  {
    "label": "BNI - BNI (BNI)",
    "value": "BNI"
  },
  {
    "label": "BPD ACEH KP - BPD ACEH KP (BPDACEH)",
    "value": "BPDACEH"
  },
  {
    "label": "BPD BALI - BPD BALI (BPDBALI)",
    "value": "BPDBALI"
  },
  {
    "label": "BPD BALI KP - BPD BALI KP (BPDBALIKP)",
    "value": "BPDBALIKP"
  },
  {
    "label": "BPD BENGKULU KP - BPD BENGKULU KP (BENGKULU)",
    "value": "BENGKULU"
  },
  {
    "label": "BPD DIY KP - BPD DIY KP (BPDDIYKP)",
    "value": "BPDDIYKP"
  },
  {
    "label": "BPD DIY SYARIAH - BPD DIY SYARIAH (BPDDIYSYA)",
    "value": "BPDDIYSYA"
  },
  {
    "label": "BPD ISTIMEWA ACEH - BPD ISTIMEWA ACEH (BPDIACEH)",
    "value": "BPDIACEH"
  },
  {
    "label": "BPD ISTIMEWA ACEH SYARIAH - BPD ISTIMEWA ACEH SYARIAH (IACEHSYA)",
    "value": "IACEHSYA"
  },
  {
    "label": "BPD JAMBI KP - BPD JAMBI KP (BPDJAMBIKP)",
    "value": "BPDJAMBIKP"
  },
  {
    "label": "BPD JATENG KP - BPD JATENG KP (BPDJATENG)",
    "value": "BPDJATENG"
  },
  {
    "label": "BPD KALBAR KP - BPD KALBAR KP (BPDKALBAR)",
    "value": "BPDKALBAR"
  },
  {
    "label": "BPD KALBAR SYARIAH - BPD KALBAR SYARIAH (KALBARSYA)",
    "value": "KALBARSYA"
  },
  {
    "label": "BPD KALSEL KP - BPD KALSEL KP (BPDKALSEL)",
    "value": "BPDKALSEL"
  },
  {
    "label": "BPD KALSEL SYARIAH - BPD KALSEL SYARIAH (KALSELSYA)",
    "value": "KALSELSYA"
  },
  {
    "label": "BPD KALTENG KP - BPD KALTENG KP (BPDKALTENG)",
    "value": "BPDKALTENG"
  },
  {
    "label": "BPD KALTIM KP - BPD KALTIM KP (BPDKALTIM)",
    "value": "BPDKALTIM"
  },
  {
    "label": "BPD KALTIM SYARIAH - BPD KALTIM SYARIAH (KALTIMSYA)",
    "value": "KALTIMSYA"
  },
  {
    "label": "BPD KUPANG - BPD KUPANG (BPD NTT)",
    "value": "BPD NTT"
  },
  {
    "label": "BPD MALUKU KP - BPD MALUKU KP (BPDMALUKU)",
    "value": "BPDMALUKU"
  },
  {
    "label": "BPD NTB KP - BPD NTB KP (BPDNTBKP)",
    "value": "BPDNTBKP"
  },
  {
    "label": "BPD NTT KP - BPD NTT KP (BPDNTTKP)",
    "value": "BPDNTTKP"
  },
  {
    "label": "BPD PAPUA KP - BPD PAPUA KP (BPDPAPUA)",
    "value": "BPDPAPUA"
  },
  {
    "label": "BPD RIAU KP - BPD RIAU KP (BPDRIAUKP)",
    "value": "BPDRIAUKP"
  },
  {
    "label": "BPD SULSEL KP - BPD SULSEL KP (BPDSULSEL)",
    "value": "BPDSULSEL"
  },
  {
    "label": "BPD SULTENG KP - BPD SULTENG KP (SULTENGKP)",
    "value": "SULTENGKP"
  },
  {
    "label": "BPD SULTRA KP - BPD SULTRA KP (BPDSULTRA)",
    "value": "BPDSULTRA"
  },
  {
    "label": "BRI - BRI (BRI)",
    "value": "BRI"
  },
  {
    "label": "BRIAGRO - BRIAGRO (BRIAGRO)",
    "value": "BRIAGRO"
  },
  {
    "label": "BTN SYARIAH - JAKARTA (BTN SYARIA)",
    "value": "BTNSYARIAH"
  },
  {
    "label": "BUKOPIN SYARIAH - BUKOPIN SYARIAH (BUKOPIN SY)",
    "value": "BUKOPIN SY"
  },
  {
    "label": "CENTRATAMA NASIONAL BANK - CENTRATAMA NASIONAL BANK (CENTRATAMA)",
    "value": "CENTRATAMA"
  },
  {
    "label": "CIMB NIAGA - CIMB NIAGA (BCMN)",
    "value": "BCMN"
  },
  {
    "label": "cimb niaga syariah - CIMB NIAGA SYARIAH (CIMB SYRH)",
    "value": "CIMB SYRH"
  },
  {
    "label": "CITIBANK - JL. SUDIRMAN JAKARTA (CITIBANK)",
    "value": "CITIBANK"
  },
  {
    "label": "CITIZEN NATIONAL BANK - KP OPERATIONAL SURABAYA (CNB)",
    "value": "CNB"
  },
  {
    "label": "DANAMON SYARIAH - DANAMON SYARIAH (DANAMON SY)",
    "value": "DANAMON SY"
  },
  {
    "label": "DEUTSCHE BANK - JAKARTA (DEUTSCHE)",
    "value": "DEUTSCHE"
  },
  {
    "label": "H S B C - H S B C (HSBC)",
    "value": "HSBC"
  },
  {
    "label": "H S B C SYARIAH - H S B C SYARIAH (HSBCSYA)",
    "value": "HSBCSYA"
  },
  {
    "label": "HAGA BANK - HAGA BANK (HAGABANK)",
    "value": "HAGABANK"
  },
  {
    "label": "HSBC - SUDIRMAN JAKARTA (273)",
    "value": "273"
  },
  {
    "label": "JPMORGAN CHASE BANK - JPMORGAN CHASE BANK (JPMORGAN)",
    "value": "JPMORGAN"
  },
  {
    "label": "JTRUST BANK - JAKARTA (JTRUST)",
    "value": "JTRUST"
  },
  {
    "label": "LIMAN INTL BANK - LIMAN INTL BANK (LIMANBANK)",
    "value": "LIMANBANK"
  },
  {
    "label": "LIPPO BANK - LIPPO BANK (LIPPO)",
    "value": "LIPPO"
  },
  {
    "label": "MAYBANK INDOCORP - MAYBANK INDOCORP (MAYBANK)",
    "value": "MAYBANK"
  },
  {
    "label": "MAYBANK SYARIAH - MAYBANK SYARIAH (MAYBANKSYR)",
    "value": "MAYBANKSYR"
  },
  {
    "label": "Mega Syariah - Rasuna Said (MEGA SYARI)",
    "value": "MEGA SYARI"
  },
  {
    "label": "MNCBANK - MNCBANK (MNCBANK)",
    "value": "MNCBANK"
  },
  {
    "label": "NOT USED (CIMBNIAGA)",
    "value": "CIMBNIAGA"
  },
  {
    "label": "OCBC NISP - OCBC NISP (OCBCNISP)",
    "value": "OCBCNISP"
  },
  {
    "label": "OCBC SYARIAH - KANTOR PUSAT JAKARTA (OCBC SYARI)",
    "value": "OCBC SYARI"
  },
  {
    "label": "Panin Syariah - Panin Syariah Kantor Pusat (PANIN SYAR)",
    "value": "PANIN SYAR"
  },
  {
    "label": "PERMATA SYARIAH - PERMATA SYARIAH (PERMATA SY)",
    "value": "PERMATA SY"
  },
  {
    "label": "PRIMA MASTER BANK - PRIMA MASTER BANK (PRIMAMSTR)",
    "value": "PRIMAMSTR"
  },
  {
    "label": "PT BANK SINARMAS SYARIAH - PT BANK SINARMAS SYARIAH (SINARSYA)",
    "value": "SINARSYA"
  },
  {
    "label": "PT. BANK DBS INDONESIA - CABANG PALEMBANG (5897)",
    "value": "5897"
  },
  {
    "label": "PT. BANK JAGO TBK (BANKJAGO)",
    "value": "BANKJAGO"
  },
  {
    "label": "PT.BANK DBS INDONESIA - CABANG MEDAN (5895)",
    "value": "5895"
  },
  {
    "label": "PT.BANK DBS INDONESIA - CABANG SEMARANG (5896)",
    "value": "5896"
  },
  {
    "label": "PT.BANK DBS INDONESIA - CABANG SURABAYA (5894)",
    "value": "5894"
  },
  {
    "label": "PT.BANK DBS INDONESIA - KANTOR PUSAT (3570)",
    "value": "3570"
  },
  {
    "label": "RABOBANK DUTA - RABOBANK DUTA (RABOBANK)",
    "value": "RABOBANK"
  },
  {
    "label": "RBS - RBS (RBS)",
    "value": "RBS"
  },
  {
    "label": "STANCHART BANK - STANCHART BANK (STANCHART)",
    "value": "STANCHART"
  },
  {
    "label": "UOB BUANA - UOB BUANA (UOBBUANA)",
    "value": "UOBBUANA"
  }
]

export const GENDER = {
  M: 'Laki-laki',
  F: 'Perempuan'
}